<h2 mat-dialog-title class="dialog-title">Sektion bearbeiten</h2>
<mat-dialog-content class="mat-typography dialog-content">
  <form [formGroup]="frmSektion">
    <div class="form-group">
      <input type="hidden" formControlName="gebaeude_id" />
    </div>
    <div class="form-group">
      <label class="form-label" for="name">Sektion Name</label>
      <input type="text" class="form-control" id="name" formControlName="name" placeholder="Sektion Name eingeben" />
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button *ngIf="isInactive()" (click)="onRestore()">Wiederherstellen</button>
  <button mat-button *ngIf="!isInactive()" color="warn" (click)="onDelete()">Löschen</button>
  <button mat-button (click)="onDismiss()">Abbrechen</button>
  <button mat-button (click)="onConfirm()" cdkFocusInitial>Speichern</button>
</mat-dialog-actions>

